import React, { useState, useEffect } from "react";
//import { useHistory } from "react-router-dom";
import "./css/styles.css";
import TextField from "@mui/material/TextField";
import { Button } from "@mui/material";
import Card from "@mui/material/Card";
import InputAdornment from "@mui/material/InputAdornment";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import LoginIcon from "@mui/icons-material/Login";
// import Home from "./Home.png";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";


import { auth} from "../firebase";
import { useAuth } from "./AuthContext";

// import { useHistory } from "react-router-dom";
import { useNavigate } from "react-router-dom";
export default function Login() {
  const { login,logout } = useAuth();
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [User, setUser] = useState({});
  const navigate = useNavigate();
  const [loginError, setloginError] = useState("");
  const [isProcessing , setisProcessing ] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setUser(user);
    });

    return unsubscribe;
  }, []);
  const doLogin = async () => {
    if (!loginEmail || !loginPassword) {
      setloginError("Please Enter Both Email and Pasword.");
      return;
    }
    setisProcessing(true);
    try {
      // setloginError();

      await login(loginEmail, loginPassword);

      auth.currentUser
        .getIdTokenResult()
        .then((idTokenResult) => {
          setisProcessing(false);
          // Confirm the user is an Admin.
          if (!!idTokenResult.claims.admin) {
            navigate("/Dashboard");
          } else {
            logout();
            setloginError("Only Admin Can Login Here");
          }
        })
        .catch((error) => {
          setisProcessing(false);
          console.log(error);
        });
    } catch (error) {
      setisProcessing(false);
      switch (error.code) {
        case "auth/internal-error": {
          setloginError("Error! Please Try Again.");
          break;
        }
        case "auth/invalid-password": {
          setloginError("Invalid Password.");
          break;
        }
        case "auth/wrong-password": {
          setloginError("Invalid Password.");
          break;
        }
        case "auth/invalid-email": {
          setloginError("No User Found With This Email.");
          break;
        }
        case "auth/session-cookie-expired": {
          setloginError("Session Expired Please Login Again.");
          break;
        }
        case "auth/user-not-found": {
          setloginError("User Not Found.");
          break;
        }
        case "auth/invalid-credential": {
          setloginError("Invalid Credentials.");
          break;
        }
        case "auth/user-disabled": {
          setloginError("Your Account Has Been Disabled.");
          break;
        }
        default: {
          setloginError(error.message);
        }
      }
    }
  };

  return (
    <div
      className=" d-flex justify-content-center align-items-center"
      style={{ backgroundColor: "#212C62", height: "100vh" }}
    >
      <div className="align-items-center" style={{ width: 600, padding: 60 }}>
        <Card style={{ padding: 40 }}>
          <div className="d-flex justify-content-center">
            {/* <img src={logo} width="250px" style={{ marginBottom: 25 }} /> */}
          </div>
          {loginError && <Alert severity="error">{loginError}</Alert>}
          <TextField
            style={{ backgroundColor: "#fff", borderRadius: 15, marginTop: 20 }}
            className="my-4"
            fullWidth
            id="outlined-basic"
            label="Email"
            value={loginEmail}
            variant="outlined"
            onChange={(e) => setLoginEmail(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <EmailIcon />
                </InputAdornment>
              ),
            }}
          />

          <TextField
            style={{
              backgroundColor: "#fff",
              borderRadius: 15,
              marginBottom: 20,
            }}
            fullWidth
            value={loginPassword}
            id="outlined-basic"
            type="password"
            label="Password"
            onChange={(e) => setLoginPassword(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LockIcon />
                </InputAdornment>
              ),
            }}
          />

          <Button
            endIcon={isProcessing?null:<LoginIcon />}
            fullWidth
            style={{ backgroundColor: "#212C62", color: "#fff" }}
            className="my-4"
            variant="contained"
            disabled={isProcessing}
            size="large"
            onClick={() => doLogin()}
          >
            {isProcessing ? <CircularProgress sx={{ color: "white" }} size={27}/> : "Login"}

          </Button>
        </Card>
      </div>
    </div>
  );
}
